import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import * as Card from '$lib/components/ui/card';

var root_4 = $.from_html(`<p class="text-sm text-muted-foreground">Participants</p> <p class="text-lg font-semibold"> </p>`, 1);
var root_5 = $.from_html(`<p> </p>`);
var root_3 = $.from_html(`<!> <!>`, 1);

export default function ParticipantSummaryCard($$anchor, $$props) {
	$.push($$props, true);

	let showTitle = $.prop($$props, 'showTitle', 3, true);
	const sortedParticipants = $.derived(() => $$props.participants.slice().sort((a, b) => a.name.localeCompare(b.name)));

	function formatName(name) {
		if (!name) return name;

		return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
	}

	const summaryText = $.derived(() => $.get(sortedParticipants).map((p) => `${formatName(p.name)} (${p.nights}n${p.share > 1 ? `, ×${p.share}` : ''})`).join(', '));
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_2 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			$.component(node_1, () => Card.Root, ($$anchor, Card_Root) => {
				Card_Root($$anchor, {
					class: 'w-full border-teal-200 bg-teal-50/50',

					children: ($$anchor, $$slotProps) => {
						var fragment_2 = $.comment();
						var node_2 = $.first_child(fragment_2);

						$.component(node_2, () => Card.Content, ($$anchor, Card_Content) => {
							Card_Content($$anchor, {
								class: 'py-4',

								children: ($$anchor, $$slotProps) => {
									var fragment_3 = root_3();
									var node_3 = $.first_child(fragment_3);

									{
										var consequent = ($$anchor) => {
											var fragment_4 = root_4();
											var p_1 = $.sibling($.first_child(fragment_4), 2);
											var text = $.child(p_1);

											$.reset(p_1);
											$.template_effect(() => $.set_text(text, `${$$props.participants.length ?? ''} ${$$props.participants.length === 1 ? 'participant' : 'participants'}`));
											$.append($$anchor, fragment_4);
										};

										$.if(node_3, ($$render) => {
											if (showTitle()) $$render(consequent);
										});
									}

									var node_4 = $.sibling(node_3, 2);

									{
										var consequent_1 = ($$anchor) => {
											var p_2 = root_5();
											var text_1 = $.child(p_2, true);

											$.reset(p_2);

											$.template_effect(() => {
												$.set_class(p_2, 1, `text-sm text-muted-foreground ${showTitle() ? 'mt-1' : ''}`);
												$.set_text(text_1, $.get(summaryText));
											});

											$.append($$anchor, p_2);
										};

										$.if(node_4, ($$render) => {
											if ($.get(sortedParticipants).length > 0) $$render(consequent_1);
										});
									}

									$.append($$anchor, fragment_3);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_2);
					},

					$$slots: { default: true }
				});
			});

			$.append($$anchor, fragment_1);
		};

		$.if(node, ($$render) => {
			if (showTitle() || $.get(sortedParticipants).length > 0) $$render(consequent_2);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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